<template>
  <div class="settings">
    <ccs-header
      :title="'Настройки'"
      :nightTheme="true"
      :info="false"/>
    <div class="settings-content">
      <settings-card v-for="(item, index) in allowedLinks"
        @click="$router.push({ name: item.pathName, params: item.pathParams })"
        :key="index" :text="item.text" :iconName="item.iconName" :scale="item.iconScale"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { PermissionsList } from '@/helpers/permissions';

import Header from '@/layouts/Header.vue';
import SettingsCard from '@/components/settings/SettingsCard.vue';

export default {
  name: 'Settings',
  components: {
    'ccs-header': Header,
    SettingsCard,
  },
  data() {
    return {
      links: [
        {
          text: 'Роли',
          iconName: 'user',
          pathName: 'roles',
          pathParams: { page: 1 },
          requiredPermissions: [
            PermissionsList.RoleView,
          ],
        }, {
          text: 'Роли мероприятия',
          iconName: 'users-cog',
          iconScale: 5,
          pathName: 'event_roles',
          pathParams: { page: 1 },
          requiredPermissions: [
            PermissionsList.EventRoleCreate,
            PermissionsList.EventRoleUpdate,
            PermissionsList.EventRoleDelete,
          ],
        }, {
          text: 'Организации',
          iconName: 'building',
          pathName: 'organizations',
          pathParams: { page: 1 },
          requiredPermissions: [
            PermissionsList.FndOrganizationView
          ],
        }, {
          text: 'ФНД',
          iconName: 'arrows-alt',
          pathName: 'fnds',
          pathParams: { page: 1 },
          requiredPermissions: [
            PermissionsList.FndView
          ],
        }, {
          text: 'Спонсоры и партнёры',
          iconName: 'handshake',
          iconScale: 5,
          pathName: 'sponsors',
          pathParams: { page: 1 },
          requiredPermissions: [
            PermissionsList.SponsorView
          ],
        }, {
          text: 'Компетенции',
          iconName: 'sliders-h',
          pathName: 'skills',
          pathParams: { page: 1 },
          requiredPermissions: [
            PermissionsList.SkillView
          ],
        }, {
          text: 'Заявки КТ',
          iconName: 'file',
          pathName: 'control_point_requests',
          pathParams: { page: 1 },
          requiredPermissions: [
            PermissionsList.ControlPointRequestViewAll,
            PermissionsList.ControlPointRequestView,
          ],
        }, {
          text: 'Типы мероприятий',
          iconName: 'cog',
          pathName: 'event_types',
          pathParams: { page: 1 },
          requiredPermissions: [
            PermissionsList.EventTypeView,
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState('session', ['permissions']),
    allowedLinks() {
      return this.links.filter(link => this.isAccessAllowed(link.requiredPermissions));
    },
  },
  methods: {
    isAccessAllowed(requiredPermissions) {;
      let result = false;
      if (!requiredPermissions) {
        result = true;
        return result;
      } else {
        requiredPermissions.forEach(slug => {
          result = result || this.permissions[slug];
        });
        return result;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.settings {
  min-height: 100%;
  min-width: 100%;
  background: $surfaceDarker;

  &-content {
    margin: 0 33px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

}
</style>
